module.exports = __webpack_public_path__ + "img/chofu_event_on.473c11ce.svg";